// 创建文件ko.js
const kr = {
  test: '안녕하세요.',
  language: {
    privacy: "개인정보처리방침",
    service: "이용 약관",
    home: "첫 페이지"
  },
}
export default kr;



// WEBPACK FOOTER //
// ./src/lang/kr.js